// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wwrIQ","type":"styles_type__1q4eR","choices":"styles_choices__2-fds"};